import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { HeaderColor } from '@ionic-native/header-color/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { StarRatingModule } from 'angular-star-rating';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePageModule } from './home/home.module';
import { LangModule } from './modules/lang/lang.module';
import { PrivateModule } from './private/private.module';
import { ApiModule } from './services/api/api.module';
import { AuthService } from './services/api/services';
import { ApiqueryServiceProvider } from './services/apiquery-service';
import { ApiAuthInterceptor } from './services/auth/api-auth.interceptor';
import { AuthServiceGuard } from './services/auth/auth-service.guard';
import { ConsoleServiceProvider } from './services/console-service';
import { CoreProvider } from './services/core';
import { NavServiceProvider } from './services/nav-service';
import { NotificationsServiceProvider } from './services/notifications-service';
import { VersionServiceProvider } from './services/version-service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    LangModule,
    PrivateModule,
    BrowserModule,
    HomePageModule,
    IonicModule.forRoot({mode: 'md'}),
    StarRatingModule.forRoot(),
    IonicStorageModule.forRoot(),
    ApiModule.forRoot({rootUrl:'REPLACEME'}),
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    StatusBar,
    AppVersion,
    Geolocation,
    HeaderColor,
    SplashScreen,
    CoreProvider,
    NavServiceProvider,
    AuthServiceGuard,
    AuthService,
    ConsoleServiceProvider,
    VersionServiceProvider,
    ApiqueryServiceProvider,
    NotificationsServiceProvider,
    { provide: HTTP_INTERCEPTORS, useClass: ApiAuthInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
